const config = {
  // Configuration file
  api_url: process.env.REACT_APP_API_URL,
  default_locale: "en",
  default_title: "Cronika",
  supported_locales: process.env.REACT_APP_LANGS.split(","),
  infoEmail: "info@cronika.com",
  supportEmail: "support@cronika.com",
};

export default config;
